import { IconX } from '@tabler/icons-react';
import React, { useRef, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { getOrganizationList, uploadImage } from '../../api/api.global';
import { postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';

const CreateOrgModal = ({ buttonComponent, callback }) => {
    const [show, setShow] = useState(false);
    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);

    const handleClose = () => { setFile(null); setShow(false) };
    const handleShow = () => setShow(true);

    const submit = async () => {
        let postData = {
            name: document.getElementById('org-name').value.trim()
        }
        if (file) {
            postData.organizationIcon = await uploadImage(file, 'attriva-organization-logo')
        }
        if (postData?.name) {
            let resp = await postApi(postData, urlApi.createOrganization);
            if (resp.responseCode === 200) {
                toast.success('Organization created successfully');
                getOrganizationList();
                callback?.();
                handleClose();
            } else {
                toast.error('Failed to create organization');
            }
        } else {
            toast.error('Please enter organization name');
        }
    }

    const handleImageChange = (e) => {
        const localFile = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (localFile && localFile.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            e.target.value = null;
        } else {
            setFile(localFile);
        }
    }

    return (
        <>
            <div className="cursor-pointer" onClick={handleShow}>
                {buttonComponent}
            </div>
            <Modal show={show} onHide={handleClose} >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Create A new Organization</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='w-full mb-4'>
                        <p className="text-md font-semibold mb-1.5">Organization Name</p>
                        <p className="text-xs mb-2 text-gray-500">*Minimum 2 character.</p>
                        <input type="text" className="form-control w-full" placeholder="Enter Name" id='org-name' maxLength={255} />
                    </div>
                    <div className="mb-2">
                        <p className="text-md font-semibold mb-1.5">Organization Logo (optional)</p>
                        <input type="file" accept="image/*" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                        <button onClick={() => imageUploadInputRef.current.click()}>
                            <img src={file ? URL.createObjectURL(file) : (process.env.PUBLIC_URL + "/images/image-upload.png")} id='link-image-preview' className='cursor-pointer max-w-[180px] max-h-[200px] rounded-lg object-cover' alt="" />
                        </button>
                        <p className="text-xs text-gray-400">*Maximum size: 5MB , preferred ratio 1:1 ,image formats : JPEG , PNG , SVG , JPG or WEBP</p>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Create</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreateOrgModal